module.exports = __webpack_public_path__ + "static/media/22import-48.79a19e10.xlsx";